import { render, staticRenderFns } from "./moblie-fotter.vue?vue&type=template&id=46724b65&scoped=true&"
import script from "./moblie-fotter.vue?vue&type=script&lang=js&"
export * from "./moblie-fotter.vue?vue&type=script&lang=js&"
import style0 from "./moblie-fotter.vue?vue&type=style&index=0&id=46724b65&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46724b65",
  null
  
)

export default component.exports